export default __webpack_public_path__ + "89a396525c0de98da36505cb04eb9373.ttf";